// projects/actions.js

import { getAllProjects, getAllInactiveProjects } from "../../api/AppDataApi";
import { projectsInitialState } from "./projectsState";

export const makeProjectsActions = (set, get) => ({
  fetchProjects: async () => {
    set((s) => ({ projects: { ...s.projects, loading: true, error: null } }));
    try {
      const data = await getAllProjects();
      set((s) => ({ projects: { ...s.projects, loading: false, list: data } }));
    } catch (err) {
      set((s) => ({
        projects: {
          ...s.projects,
          loading: false,
          error: `Failed to load projects: ${err.message}`,
        },
      }));
      console.error("Project loading error:", err);
    }
  },
  fetchInactiveProjects: async () => {
    set((s) => ({ projects: { ...s.projects, loading: true, error: null } }));
    try {
      const data = await getAllInactiveProjects();
      set((s) => ({
        projects: { ...s.projects, loading: false, inactiveList: data },
      }));
    } catch (err) {
      set((s) => ({
        projects: {
          ...s.projects,
          loading: false,
          error: `Failed to load inactive projects: ${err.message}`,
        },
      }));
      console.error("Inactive project loading error:", err);
    }
  },
  resetInactiveProjects: () =>
    set({ projects: { ...projectsInitialState, inactiveList: [] } }),

  resetProjects: () => set({ projects: projectsInitialState }),
});
